module.exports = __webpack_public_path__ + "img/cat.11910da9.svg";